// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { activitiesCreate, activitiesDelete, activitiesList, activitiesReorder, activitiesUpdate, analyticsCrossOrgReport, analyticsOrgReport, assetsConfirmUpload, assetsDelete, assetsList, assetsStartUpload, assetsUpdate, auditActions, auditExport, auditList, auditMine, authChangePassword, authForgotPassword, authLogin, authLogout, authMe, authRefresh, authResetPassword, authResetPreview, authUpdateMe, brandAddComment, brandApprove, brandConfigsAddContentPillar, brandConfigsAddVoicePillar, brandConfigsCreateForOrg, brandConfigsDelete, brandConfigsDeleteContentPillar, brandConfigsDeleteVoicePillar, brandConfigsGet, brandConfigsReorderContentPillars, brandConfigsReorderVoicePillars, brandConfigsSaveTipSheet, brandConfigsUpdate, brandConfigsUpdateContentPillar, brandConfigsUpdateVoicePillar, brandResolveComment, brandReview, brandTemplatesCreate, brandTemplatesDuplicate, brandTemplatesList, dashboardPageSnapshot, dashboardPillarCoverage, dashboardRoster, dashboardSetup, downloadsFile, downloadsGet, draftsConfirmPosted, draftsCreate, draftsDelete, draftsDiscardPreview, draftsGet, draftsGrowth, draftsHistory, draftsList, draftsPostingSummary, draftsPreviewPost, draftsUpdate, frameworksCreate, frameworksDelete, frameworksList, frameworksUpdate, generationGenerateMine, generationMyMonth, healthLive, healthReady, healthWorker, invitationsAccept, invitationsCreate, invitationsList, invitationsPreview, invitationsRevoke, mentionsList, mentionsMonth, mentionsSummary, momentsAdd, momentsArchive, momentsConfirmMedia, momentsGet, momentsGetIdeas, momentsList, momentsRemoveMedia, momentsRestore, momentsStartMediaUpload, momentsUpdate, monthlyReportsCompute, monthlyReportsForMonth, monthlyReportsMine, notebookArchiveIdea, notebookCounts, notebookIdeas, notebookPillars, notebookRestoreIdea, notebookUpdateIdea, type Options, orgsArchive, orgsCreate, orgsExportLink, orgsExports, orgsGet, orgsList, orgsMine, orgsRemove, orgsRestore, orgsRetryExport, orgsUpdate, plansAddEvent, plansAddPost, plansByMonth, plansCreate, plansDelete, plansDeleteEvent, plansDeletePost, plansGenerateEmployees, plansGenerateMonth, plansGeneratePage, plansGet, plansList, plansSetPrompts, plansUpdate, plansUpdateEvent, plansUpdatePost, promptsAddMine, promptsCreateForConfig, promptsDeleteForConfig, promptsDeleteMine, promptsDuplicateMine, promptsListForConfig, promptsMine, promptsUpdateForConfig, promptsUpdateMine, reportsConfirmUpload, reportsDelete, reportsList, reportsStartUpload, socialPageAnalytics, socialPageConnect, socialPageDisconnect, socialPagePostHistory, socialPagePublishPost, socialPageRefreshPages, socialPageSelectPages, socialPageSetPrimary, socialPageStatus, socialPageSync, systemErrors, systemHealth, systemReport, trackerGet, trackerHistory, trackerLess, trackerPick, trackerTap, trackerUndo, trackerUpdateSettings, usersCreate, usersGet, usersList, usersUpdate, voiceAddSample, voiceDeleteSample, voiceMine, voiceOptions, voiceStageOne, voiceStageThree, voiceTeamReadiness, voiceUpdateSample, webhooksEmail } from '../sdk.gen';
import type { ActivitiesCreateData, ActivitiesCreateError, ActivitiesCreateResponse, ActivitiesDeleteData, ActivitiesDeleteError, ActivitiesDeleteResponse, ActivitiesListData, ActivitiesListResponse, ActivitiesReorderData, ActivitiesReorderError, ActivitiesReorderResponse, ActivitiesUpdateData, ActivitiesUpdateError, ActivitiesUpdateResponse, AnalyticsCrossOrgReportData, AnalyticsCrossOrgReportError, AnalyticsCrossOrgReportResponse, AnalyticsOrgReportData, AnalyticsOrgReportError, AnalyticsOrgReportResponse, AssetsConfirmUploadData, AssetsConfirmUploadError, AssetsConfirmUploadResponse, AssetsDeleteData, AssetsDeleteError, AssetsDeleteResponse, AssetsListData, AssetsListError, AssetsListResponse, AssetsStartUploadData, AssetsStartUploadError, AssetsStartUploadResponse, AssetsUpdateData, AssetsUpdateError, AssetsUpdateResponse, AuditActionsData, AuditActionsResponse, AuditExportData, AuditExportError, AuditListData, AuditListError, AuditListResponse, AuditMineData, AuditMineError, AuditMineResponse, AuthChangePasswordData, AuthChangePasswordError, AuthChangePasswordResponse, AuthForgotPasswordData, AuthForgotPasswordError, AuthForgotPasswordResponse, AuthLoginData, AuthLoginError, AuthLoginResponse, AuthLogoutData, AuthLogoutResponse, AuthMeData, AuthMeResponse, AuthRefreshData, AuthRefreshResponse, AuthResetPasswordData, AuthResetPasswordError, AuthResetPasswordResponse, AuthResetPreviewData, AuthResetPreviewError, AuthResetPreviewResponse, AuthUpdateMeData, AuthUpdateMeError, AuthUpdateMeResponse, BrandAddCommentData, BrandAddCommentError, BrandAddCommentResponse, BrandApproveData, BrandApproveError, BrandApproveResponse, BrandConfigsAddContentPillarData, BrandConfigsAddContentPillarError, BrandConfigsAddContentPillarResponse, BrandConfigsAddVoicePillarData, BrandConfigsAddVoicePillarError, BrandConfigsAddVoicePillarResponse, BrandConfigsCreateForOrgData, BrandConfigsCreateForOrgError, BrandConfigsCreateForOrgResponse, BrandConfigsDeleteContentPillarData, BrandConfigsDeleteContentPillarError, BrandConfigsDeleteContentPillarResponse, BrandConfigsDeleteData, BrandConfigsDeleteError, BrandConfigsDeleteResponse, BrandConfigsDeleteVoicePillarData, BrandConfigsDeleteVoicePillarError, BrandConfigsDeleteVoicePillarResponse, BrandConfigsGetData, BrandConfigsGetError, BrandConfigsGetResponse, BrandConfigsReorderContentPillarsData, BrandConfigsReorderContentPillarsError, BrandConfigsReorderContentPillarsResponse, BrandConfigsReorderVoicePillarsData, BrandConfigsReorderVoicePillarsError, BrandConfigsReorderVoicePillarsResponse, BrandConfigsSaveTipSheetData, BrandConfigsSaveTipSheetError, BrandConfigsSaveTipSheetResponse, BrandConfigsUpdateContentPillarData, BrandConfigsUpdateContentPillarError, BrandConfigsUpdateContentPillarResponse, BrandConfigsUpdateData, BrandConfigsUpdateError, BrandConfigsUpdateResponse, BrandConfigsUpdateVoicePillarData, BrandConfigsUpdateVoicePillarError, BrandConfigsUpdateVoicePillarResponse, BrandResolveCommentData, BrandResolveCommentError, BrandResolveCommentResponse, BrandReviewData, BrandReviewError, BrandReviewResponse, BrandTemplatesCreateData, BrandTemplatesCreateError, BrandTemplatesCreateResponse, BrandTemplatesDuplicateData, BrandTemplatesDuplicateError, BrandTemplatesDuplicateResponse, BrandTemplatesListData, BrandTemplatesListError, BrandTemplatesListResponse, DashboardPageSnapshotData, DashboardPageSnapshotError, DashboardPageSnapshotResponse, DashboardPillarCoverageData, DashboardPillarCoverageError, DashboardPillarCoverageResponse, DashboardRosterData, DashboardRosterError, DashboardRosterResponse, DashboardSetupData, DashboardSetupError, DashboardSetupResponse, DownloadsFileData, DownloadsFileError, DownloadsGetData, DownloadsGetError, DownloadsGetResponse, DraftsConfirmPostedData, DraftsConfirmPostedError, DraftsConfirmPostedResponse, DraftsCreateData, DraftsCreateError, DraftsCreateResponse, DraftsDeleteData, DraftsDeleteError, DraftsDeleteResponse, DraftsDiscardPreviewData, DraftsDiscardPreviewError, DraftsDiscardPreviewResponse, DraftsGetData, DraftsGetError, DraftsGetResponse, DraftsGrowthData, DraftsGrowthResponse, DraftsHistoryData, DraftsHistoryError, DraftsHistoryResponse, DraftsListData, DraftsListResponse, DraftsPostingSummaryData, DraftsPostingSummaryError, DraftsPostingSummaryResponse, DraftsPreviewPostData, DraftsPreviewPostError, DraftsPreviewPostResponse, DraftsUpdateData, DraftsUpdateError, DraftsUpdateResponse, FrameworksCreateData, FrameworksCreateError, FrameworksCreateResponse, FrameworksDeleteData, FrameworksDeleteError, FrameworksDeleteResponse, FrameworksListData, FrameworksListError, FrameworksListResponse, FrameworksUpdateData, FrameworksUpdateError, FrameworksUpdateResponse, GenerationGenerateMineData, GenerationGenerateMineResponse, GenerationMyMonthData, GenerationMyMonthResponse, HealthLiveData, HealthLiveResponse, HealthReadyData, HealthReadyResponse, HealthWorkerData, HealthWorkerResponse, InvitationsAcceptData, InvitationsAcceptError, InvitationsAcceptResponse, InvitationsCreateData, InvitationsCreateError, InvitationsCreateResponse, InvitationsListData, InvitationsListError, InvitationsListResponse, InvitationsPreviewData, InvitationsPreviewError, InvitationsPreviewResponse, InvitationsRevokeData, InvitationsRevokeError, InvitationsRevokeResponse, MentionsListData, MentionsListError, MentionsListResponse, MentionsMonthData, MentionsMonthError, MentionsMonthResponse, MentionsSummaryData, MentionsSummaryError, MentionsSummaryResponse, MomentsAddData, MomentsAddError, MomentsAddResponse, MomentsArchiveData, MomentsArchiveError, MomentsArchiveResponse, MomentsConfirmMediaData, MomentsConfirmMediaError, MomentsConfirmMediaResponse, MomentsGetData, MomentsGetError, MomentsGetIdeasData, MomentsGetIdeasError, MomentsGetIdeasResponse, MomentsGetResponse, MomentsListData, MomentsListError, MomentsListResponse, MomentsRemoveMediaData, MomentsRemoveMediaError, MomentsRemoveMediaResponse, MomentsRestoreData, MomentsRestoreError, MomentsRestoreResponse, MomentsStartMediaUploadData, MomentsStartMediaUploadError, MomentsStartMediaUploadResponse, MomentsUpdateData, MomentsUpdateError, MomentsUpdateResponse, MonthlyReportsComputeData, MonthlyReportsComputeError, MonthlyReportsComputeResponse, MonthlyReportsForMonthData, MonthlyReportsForMonthError, MonthlyReportsForMonthResponse, MonthlyReportsMineData, MonthlyReportsMineError, MonthlyReportsMineResponse, NotebookArchiveIdeaData, NotebookArchiveIdeaError, NotebookArchiveIdeaResponse, NotebookCountsData, NotebookCountsResponse, NotebookIdeasData, NotebookIdeasError, NotebookIdeasResponse, NotebookPillarsData, NotebookPillarsResponse, NotebookRestoreIdeaData, NotebookRestoreIdeaError, NotebookRestoreIdeaResponse, NotebookUpdateIdeaData, NotebookUpdateIdeaError, NotebookUpdateIdeaResponse, OrgsArchiveData, OrgsArchiveError, OrgsArchiveResponse, OrgsCreateData, OrgsCreateError, OrgsCreateResponse, OrgsExportLinkData, OrgsExportLinkError, OrgsExportLinkResponse, OrgsExportsData, OrgsExportsError, OrgsExportsResponse, OrgsGetData, OrgsGetError, OrgsGetResponse, OrgsListData, OrgsListError, OrgsListResponse, OrgsMineData, OrgsMineResponse, OrgsRemoveData, OrgsRemoveError, OrgsRemoveResponse, OrgsRestoreData, OrgsRestoreError, OrgsRestoreResponse, OrgsRetryExportData, OrgsRetryExportError, OrgsRetryExportResponse, OrgsUpdateData, OrgsUpdateError, OrgsUpdateResponse, PlansAddEventData, PlansAddEventError, PlansAddEventResponse, PlansAddPostData, PlansAddPostError, PlansAddPostResponse, PlansByMonthData, PlansByMonthError, PlansByMonthResponse, PlansCreateData, PlansCreateError, PlansCreateResponse, PlansDeleteData, PlansDeleteError, PlansDeleteEventData, PlansDeleteEventError, PlansDeleteEventResponse, PlansDeletePostData, PlansDeletePostError, PlansDeletePostResponse, PlansDeleteResponse, PlansGenerateEmployeesData, PlansGenerateEmployeesError, PlansGenerateEmployeesResponse, PlansGenerateMonthData, PlansGenerateMonthError, PlansGenerateMonthResponse, PlansGeneratePageData, PlansGeneratePageError, PlansGeneratePageResponse, PlansGetData, PlansGetError, PlansGetResponse, PlansListData, PlansListError, PlansListResponse, PlansSetPromptsData, PlansSetPromptsError, PlansSetPromptsResponse, PlansUpdateData, PlansUpdateError, PlansUpdateEventData, PlansUpdateEventError, PlansUpdateEventResponse, PlansUpdatePostData, PlansUpdatePostError, PlansUpdatePostResponse, PlansUpdateResponse, PromptsAddMineData, PromptsAddMineError, PromptsAddMineResponse, PromptsCreateForConfigData, PromptsCreateForConfigError, PromptsCreateForConfigResponse, PromptsDeleteForConfigData, PromptsDeleteForConfigError, PromptsDeleteForConfigResponse, PromptsDeleteMineData, PromptsDeleteMineError, PromptsDeleteMineResponse, PromptsDuplicateMineData, PromptsDuplicateMineError, PromptsDuplicateMineResponse, PromptsListForConfigData, PromptsListForConfigError, PromptsListForConfigResponse, PromptsMineData, PromptsMineError, PromptsMineResponse, PromptsUpdateForConfigData, PromptsUpdateForConfigError, PromptsUpdateForConfigResponse, PromptsUpdateMineData, PromptsUpdateMineError, PromptsUpdateMineResponse, ReportsConfirmUploadData, ReportsConfirmUploadError, ReportsConfirmUploadResponse, ReportsDeleteData, ReportsDeleteError, ReportsDeleteResponse, ReportsListData, ReportsListError, ReportsListResponse, ReportsStartUploadData, ReportsStartUploadError, ReportsStartUploadResponse, SocialPageAnalyticsData, SocialPageAnalyticsError, SocialPageAnalyticsResponse, SocialPageConnectData, SocialPageConnectError, SocialPageConnectResponse, SocialPageDisconnectData, SocialPageDisconnectError, SocialPageDisconnectResponse, SocialPagePostHistoryData, SocialPagePostHistoryError, SocialPagePostHistoryResponse, SocialPagePublishPostData, SocialPagePublishPostError, SocialPagePublishPostResponse, SocialPageRefreshPagesData, SocialPageRefreshPagesError, SocialPageRefreshPagesResponse, SocialPageSelectPagesData, SocialPageSelectPagesError, SocialPageSelectPagesResponse, SocialPageSetPrimaryData, SocialPageSetPrimaryError, SocialPageSetPrimaryResponse, SocialPageStatusData, SocialPageStatusError, SocialPageStatusResponse, SocialPageSyncData, SocialPageSyncError, SocialPageSyncResponse, SystemErrorsData, SystemErrorsError, SystemErrorsResponse, SystemHealthData, SystemHealthResponse, SystemReportData, SystemReportError, SystemReportResponse, TrackerGetData, TrackerGetResponse, TrackerHistoryData, TrackerHistoryResponse, TrackerLessData, TrackerLessError, TrackerLessResponse, TrackerPickData, TrackerPickError, TrackerPickResponse, TrackerTapData, TrackerTapError, TrackerTapResponse, TrackerUndoData, TrackerUndoError, TrackerUndoResponse, TrackerUpdateSettingsData, TrackerUpdateSettingsError, TrackerUpdateSettingsResponse, UsersCreateData, UsersCreateError, UsersCreateResponse, UsersGetData, UsersGetError, UsersGetResponse, UsersListData, UsersListError, UsersListResponse, UsersUpdateData, UsersUpdateError, UsersUpdateResponse, VoiceAddSampleData, VoiceAddSampleError, VoiceAddSampleResponse, VoiceDeleteSampleData, VoiceDeleteSampleError, VoiceDeleteSampleResponse, VoiceMineData, VoiceMineResponse, VoiceOptionsData, VoiceOptionsResponse, VoiceStageOneData, VoiceStageOneError, VoiceStageOneResponse, VoiceStageThreeData, VoiceStageThreeError, VoiceStageThreeResponse, VoiceTeamReadinessData, VoiceTeamReadinessError, VoiceTeamReadinessResponse, VoiceUpdateSampleData, VoiceUpdateSampleError, VoiceUpdateSampleResponse, WebhooksEmailData, WebhooksEmailError, WebhooksEmailResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const healthLiveQueryKey = (options?: Options<HealthLiveData>) => createQueryKey('healthLive', options);

/**
 * Live
 */
export const healthLiveOptions = (options?: Options<HealthLiveData>) => queryOptions<HealthLiveResponse, DefaultError, HealthLiveResponse, ReturnType<typeof healthLiveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthLive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthLiveQueryKey(options)
});

export const healthWorkerQueryKey = (options?: Options<HealthWorkerData>) => createQueryKey('healthWorker', options);

/**
 * Worker
 *
 * Is a worker alive? 200 when one has heartbeated recently, 503 otherwise.
 *
 * For an outside uptime monitor to poll. The thing that alerts must not be
 * the thing that fails, so the worker cannot be the one to say it is down;
 * the API answers from the heartbeat the worker leaves in the database.
 */
export const healthWorkerOptions = (options?: Options<HealthWorkerData>) => queryOptions<HealthWorkerResponse, DefaultError, HealthWorkerResponse, ReturnType<typeof healthWorkerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthWorker({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthWorkerQueryKey(options)
});

export const healthReadyQueryKey = (options?: Options<HealthReadyData>) => createQueryKey('healthReady', options);

/**
 * Ready
 */
export const healthReadyOptions = (options?: Options<HealthReadyData>) => queryOptions<HealthReadyResponse, DefaultError, HealthReadyResponse, ReturnType<typeof healthReadyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthReady({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthReadyQueryKey(options)
});

/**
 * Login
 */
export const authLoginMutation = (options?: Partial<Options<AuthLoginData>>): UseMutationOptions<AuthLoginResponse, AuthLoginError, Options<AuthLoginData>> => {
    const mutationOptions: UseMutationOptions<AuthLoginResponse, AuthLoginError, Options<AuthLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refresh
 */
export const authRefreshMutation = (options?: Partial<Options<AuthRefreshData>>): UseMutationOptions<AuthRefreshResponse, DefaultError, Options<AuthRefreshData>> => {
    const mutationOptions: UseMutationOptions<AuthRefreshResponse, DefaultError, Options<AuthRefreshData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authRefresh({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Logout
 */
export const authLogoutMutation = (options?: Partial<Options<AuthLogoutData>>): UseMutationOptions<AuthLogoutResponse, DefaultError, Options<AuthLogoutData>> => {
    const mutationOptions: UseMutationOptions<AuthLogoutResponse, DefaultError, Options<AuthLogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authLogout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authMeQueryKey = (options?: Options<AuthMeData>) => createQueryKey('authMe', options);

/**
 * Me
 */
export const authMeOptions = (options?: Options<AuthMeData>) => queryOptions<AuthMeResponse, DefaultError, AuthMeResponse, ReturnType<typeof authMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authMeQueryKey(options)
});

/**
 * Updateme
 *
 * Your own name and title. Nothing else about you is yours to change here.
 */
export const authUpdateMeMutation = (options?: Partial<Options<AuthUpdateMeData>>): UseMutationOptions<AuthUpdateMeResponse, AuthUpdateMeError, Options<AuthUpdateMeData>> => {
    const mutationOptions: UseMutationOptions<AuthUpdateMeResponse, AuthUpdateMeError, Options<AuthUpdateMeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authUpdateMe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Changepassword
 *
 * A new password, proven by the current one. Other devices are signed out.
 */
export const authChangePasswordMutation = (options?: Partial<Options<AuthChangePasswordData>>): UseMutationOptions<AuthChangePasswordResponse, AuthChangePasswordError, Options<AuthChangePasswordData>> => {
    const mutationOptions: UseMutationOptions<AuthChangePasswordResponse, AuthChangePasswordError, Options<AuthChangePasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authChangePassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Forgotpassword
 *
 * Email a reset link. The answer is the same whether or not the address
 * is known: anything else is a way to list accounts.
 */
export const authForgotPasswordMutation = (options?: Partial<Options<AuthForgotPasswordData>>): UseMutationOptions<AuthForgotPasswordResponse, AuthForgotPasswordError, Options<AuthForgotPasswordData>> => {
    const mutationOptions: UseMutationOptions<AuthForgotPasswordResponse, AuthForgotPasswordError, Options<AuthForgotPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authForgotPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authResetPreviewQueryKey = (options: Options<AuthResetPreviewData>) => createQueryKey('authResetPreview', options);

/**
 * Resetpreview
 *
 * Whether the link still works, so the page can say so before the form.
 */
export const authResetPreviewOptions = (options: Options<AuthResetPreviewData>) => queryOptions<AuthResetPreviewResponse, AuthResetPreviewError, AuthResetPreviewResponse, ReturnType<typeof authResetPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authResetPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authResetPreviewQueryKey(options)
});

/**
 * Resetpassword
 *
 * Set the new password and sign in, in one step. Every other session
 * for the account is signed out.
 */
export const authResetPasswordMutation = (options?: Partial<Options<AuthResetPasswordData>>): UseMutationOptions<AuthResetPasswordResponse, AuthResetPasswordError, Options<AuthResetPasswordData>> => {
    const mutationOptions: UseMutationOptions<AuthResetPasswordResponse, AuthResetPasswordError, Options<AuthResetPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authResetPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersListQueryKey = (options?: Options<UsersListData>) => createQueryKey('usersList', options);

/**
 * List
 */
export const usersListOptions = (options?: Options<UsersListData>) => queryOptions<UsersListResponse, UsersListError, UsersListResponse, ReturnType<typeof usersListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersListQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const usersListInfiniteQueryKey = (options?: Options<UsersListData>): QueryKey<Options<UsersListData>> => createQueryKey('usersList', options, true);

/**
 * List
 */
export const usersListInfiniteOptions = (options?: Options<UsersListData>) => {
    const opts = infiniteQueryOptions<UsersListResponse, UsersListError, InfiniteData<UsersListResponse>, QueryKey<Options<UsersListData>>, number | Pick<QueryKey<Options<UsersListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<UsersListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await usersList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create
 */
export const usersCreateMutation = (options?: Partial<Options<UsersCreateData>>): UseMutationOptions<UsersCreateResponse, UsersCreateError, Options<UsersCreateData>> => {
    const mutationOptions: UseMutationOptions<UsersCreateResponse, UsersCreateError, Options<UsersCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetQueryKey = (options: Options<UsersGetData>) => createQueryKey('usersGet', options);

/**
 * Get
 */
export const usersGetOptions = (options: Options<UsersGetData>) => queryOptions<UsersGetResponse, UsersGetError, UsersGetResponse, ReturnType<typeof usersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersGetQueryKey(options)
});

/**
 * Update
 */
export const usersUpdateMutation = (options?: Partial<Options<UsersUpdateData>>): UseMutationOptions<UsersUpdateResponse, UsersUpdateError, Options<UsersUpdateData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateResponse, UsersUpdateError, Options<UsersUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgsListQueryKey = (options?: Options<OrgsListData>) => createQueryKey('orgsList', options);

/**
 * List
 *
 * Active orgs by default; archived and removed ones are their own lists.
 */
export const orgsListOptions = (options?: Options<OrgsListData>) => queryOptions<OrgsListResponse, OrgsListError, OrgsListResponse, ReturnType<typeof orgsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgsListQueryKey(options)
});

export const orgsListInfiniteQueryKey = (options?: Options<OrgsListData>): QueryKey<Options<OrgsListData>> => createQueryKey('orgsList', options, true);

/**
 * List
 *
 * Active orgs by default; archived and removed ones are their own lists.
 */
export const orgsListInfiniteOptions = (options?: Options<OrgsListData>) => {
    const opts = infiniteQueryOptions<OrgsListResponse, OrgsListError, InfiniteData<OrgsListResponse>, QueryKey<Options<OrgsListData>>, number | Pick<QueryKey<Options<OrgsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<OrgsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await orgsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: orgsListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create
 */
export const orgsCreateMutation = (options?: Partial<Options<OrgsCreateData>>): UseMutationOptions<OrgsCreateResponse, OrgsCreateError, Options<OrgsCreateData>> => {
    const mutationOptions: UseMutationOptions<OrgsCreateResponse, OrgsCreateError, Options<OrgsCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgsCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgsMineQueryKey = (options?: Options<OrgsMineData>) => createQueryKey('orgsMine', options);

/**
 * Mine
 *
 * The caller's own organization (SMM and employees).
 */
export const orgsMineOptions = (options?: Options<OrgsMineData>) => queryOptions<OrgsMineResponse, DefaultError, OrgsMineResponse, ReturnType<typeof orgsMineQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgsMine({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgsMineQueryKey(options)
});

export const orgsGetQueryKey = (options: Options<OrgsGetData>) => createQueryKey('orgsGet', options);

/**
 * Get
 */
export const orgsGetOptions = (options: Options<OrgsGetData>) => queryOptions<OrgsGetResponse, OrgsGetError, OrgsGetResponse, ReturnType<typeof orgsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgsGetQueryKey(options)
});

/**
 * Update
 */
export const orgsUpdateMutation = (options?: Partial<Options<OrgsUpdateData>>): UseMutationOptions<OrgsUpdateResponse, OrgsUpdateError, Options<OrgsUpdateData>> => {
    const mutationOptions: UseMutationOptions<OrgsUpdateResponse, OrgsUpdateError, Options<OrgsUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgsUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const brandTemplatesListQueryKey = (options?: Options<BrandTemplatesListData>) => createQueryKey('brandTemplatesList', options);

/**
 * List
 */
export const brandTemplatesListOptions = (options?: Options<BrandTemplatesListData>) => queryOptions<BrandTemplatesListResponse, BrandTemplatesListError, BrandTemplatesListResponse, ReturnType<typeof brandTemplatesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await brandTemplatesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: brandTemplatesListQueryKey(options)
});

export const brandTemplatesListInfiniteQueryKey = (options?: Options<BrandTemplatesListData>): QueryKey<Options<BrandTemplatesListData>> => createQueryKey('brandTemplatesList', options, true);

/**
 * List
 */
export const brandTemplatesListInfiniteOptions = (options?: Options<BrandTemplatesListData>) => {
    const opts = infiniteQueryOptions<BrandTemplatesListResponse, BrandTemplatesListError, InfiniteData<BrandTemplatesListResponse>, QueryKey<Options<BrandTemplatesListData>>, number | Pick<QueryKey<Options<BrandTemplatesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<BrandTemplatesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await brandTemplatesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: brandTemplatesListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create
 */
export const brandTemplatesCreateMutation = (options?: Partial<Options<BrandTemplatesCreateData>>): UseMutationOptions<BrandTemplatesCreateResponse, BrandTemplatesCreateError, Options<BrandTemplatesCreateData>> => {
    const mutationOptions: UseMutationOptions<BrandTemplatesCreateResponse, BrandTemplatesCreateError, Options<BrandTemplatesCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandTemplatesCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Duplicate
 */
export const brandTemplatesDuplicateMutation = (options?: Partial<Options<BrandTemplatesDuplicateData>>): UseMutationOptions<BrandTemplatesDuplicateResponse, BrandTemplatesDuplicateError, Options<BrandTemplatesDuplicateData>> => {
    const mutationOptions: UseMutationOptions<BrandTemplatesDuplicateResponse, BrandTemplatesDuplicateError, Options<BrandTemplatesDuplicateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandTemplatesDuplicate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Createfororg
 *
 * Start a client's brand setup from nothing, when no template fits.
 */
export const brandConfigsCreateForOrgMutation = (options?: Partial<Options<BrandConfigsCreateForOrgData>>): UseMutationOptions<BrandConfigsCreateForOrgResponse, BrandConfigsCreateForOrgError, Options<BrandConfigsCreateForOrgData>> => {
    const mutationOptions: UseMutationOptions<BrandConfigsCreateForOrgResponse, BrandConfigsCreateForOrgError, Options<BrandConfigsCreateForOrgData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandConfigsCreateForOrg({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete
 */
export const brandConfigsDeleteMutation = (options?: Partial<Options<BrandConfigsDeleteData>>): UseMutationOptions<BrandConfigsDeleteResponse, BrandConfigsDeleteError, Options<BrandConfigsDeleteData>> => {
    const mutationOptions: UseMutationOptions<BrandConfigsDeleteResponse, BrandConfigsDeleteError, Options<BrandConfigsDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandConfigsDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const brandConfigsGetQueryKey = (options: Options<BrandConfigsGetData>) => createQueryKey('brandConfigsGet', options);

/**
 * Get
 */
export const brandConfigsGetOptions = (options: Options<BrandConfigsGetData>) => queryOptions<BrandConfigsGetResponse, BrandConfigsGetError, BrandConfigsGetResponse, ReturnType<typeof brandConfigsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await brandConfigsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: brandConfigsGetQueryKey(options)
});

/**
 * Update
 */
export const brandConfigsUpdateMutation = (options?: Partial<Options<BrandConfigsUpdateData>>): UseMutationOptions<BrandConfigsUpdateResponse, BrandConfigsUpdateError, Options<BrandConfigsUpdateData>> => {
    const mutationOptions: UseMutationOptions<BrandConfigsUpdateResponse, BrandConfigsUpdateError, Options<BrandConfigsUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandConfigsUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Addvoicepillar
 */
export const brandConfigsAddVoicePillarMutation = (options?: Partial<Options<BrandConfigsAddVoicePillarData>>): UseMutationOptions<BrandConfigsAddVoicePillarResponse, BrandConfigsAddVoicePillarError, Options<BrandConfigsAddVoicePillarData>> => {
    const mutationOptions: UseMutationOptions<BrandConfigsAddVoicePillarResponse, BrandConfigsAddVoicePillarError, Options<BrandConfigsAddVoicePillarData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandConfigsAddVoicePillar({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deletevoicepillar
 */
export const brandConfigsDeleteVoicePillarMutation = (options?: Partial<Options<BrandConfigsDeleteVoicePillarData>>): UseMutationOptions<BrandConfigsDeleteVoicePillarResponse, BrandConfigsDeleteVoicePillarError, Options<BrandConfigsDeleteVoicePillarData>> => {
    const mutationOptions: UseMutationOptions<BrandConfigsDeleteVoicePillarResponse, BrandConfigsDeleteVoicePillarError, Options<BrandConfigsDeleteVoicePillarData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandConfigsDeleteVoicePillar({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updatevoicepillar
 */
export const brandConfigsUpdateVoicePillarMutation = (options?: Partial<Options<BrandConfigsUpdateVoicePillarData>>): UseMutationOptions<BrandConfigsUpdateVoicePillarResponse, BrandConfigsUpdateVoicePillarError, Options<BrandConfigsUpdateVoicePillarData>> => {
    const mutationOptions: UseMutationOptions<BrandConfigsUpdateVoicePillarResponse, BrandConfigsUpdateVoicePillarError, Options<BrandConfigsUpdateVoicePillarData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandConfigsUpdateVoicePillar({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reordervoicepillars
 */
export const brandConfigsReorderVoicePillarsMutation = (options?: Partial<Options<BrandConfigsReorderVoicePillarsData>>): UseMutationOptions<BrandConfigsReorderVoicePillarsResponse, BrandConfigsReorderVoicePillarsError, Options<BrandConfigsReorderVoicePillarsData>> => {
    const mutationOptions: UseMutationOptions<BrandConfigsReorderVoicePillarsResponse, BrandConfigsReorderVoicePillarsError, Options<BrandConfigsReorderVoicePillarsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandConfigsReorderVoicePillars({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Addcontentpillar
 */
export const brandConfigsAddContentPillarMutation = (options?: Partial<Options<BrandConfigsAddContentPillarData>>): UseMutationOptions<BrandConfigsAddContentPillarResponse, BrandConfigsAddContentPillarError, Options<BrandConfigsAddContentPillarData>> => {
    const mutationOptions: UseMutationOptions<BrandConfigsAddContentPillarResponse, BrandConfigsAddContentPillarError, Options<BrandConfigsAddContentPillarData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandConfigsAddContentPillar({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deletecontentpillar
 */
export const brandConfigsDeleteContentPillarMutation = (options?: Partial<Options<BrandConfigsDeleteContentPillarData>>): UseMutationOptions<BrandConfigsDeleteContentPillarResponse, BrandConfigsDeleteContentPillarError, Options<BrandConfigsDeleteContentPillarData>> => {
    const mutationOptions: UseMutationOptions<BrandConfigsDeleteContentPillarResponse, BrandConfigsDeleteContentPillarError, Options<BrandConfigsDeleteContentPillarData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandConfigsDeleteContentPillar({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updatecontentpillar
 */
export const brandConfigsUpdateContentPillarMutation = (options?: Partial<Options<BrandConfigsUpdateContentPillarData>>): UseMutationOptions<BrandConfigsUpdateContentPillarResponse, BrandConfigsUpdateContentPillarError, Options<BrandConfigsUpdateContentPillarData>> => {
    const mutationOptions: UseMutationOptions<BrandConfigsUpdateContentPillarResponse, BrandConfigsUpdateContentPillarError, Options<BrandConfigsUpdateContentPillarData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandConfigsUpdateContentPillar({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reordercontentpillars
 */
export const brandConfigsReorderContentPillarsMutation = (options?: Partial<Options<BrandConfigsReorderContentPillarsData>>): UseMutationOptions<BrandConfigsReorderContentPillarsResponse, BrandConfigsReorderContentPillarsError, Options<BrandConfigsReorderContentPillarsData>> => {
    const mutationOptions: UseMutationOptions<BrandConfigsReorderContentPillarsResponse, BrandConfigsReorderContentPillarsError, Options<BrandConfigsReorderContentPillarsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandConfigsReorderContentPillars({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Savetipsheet
 */
export const brandConfigsSaveTipSheetMutation = (options?: Partial<Options<BrandConfigsSaveTipSheetData>>): UseMutationOptions<BrandConfigsSaveTipSheetResponse, BrandConfigsSaveTipSheetError, Options<BrandConfigsSaveTipSheetData>> => {
    const mutationOptions: UseMutationOptions<BrandConfigsSaveTipSheetResponse, BrandConfigsSaveTipSheetError, Options<BrandConfigsSaveTipSheetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandConfigsSaveTipSheet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const brandReviewQueryKey = (options?: Options<BrandReviewData>) => createQueryKey('brandReview', options);

/**
 * Review
 *
 * The org's setup with its review state. Empty until The Motherhood builds one.
 */
export const brandReviewOptions = (options?: Options<BrandReviewData>) => queryOptions<BrandReviewResponse, BrandReviewError, BrandReviewResponse, ReturnType<typeof brandReviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await brandReview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: brandReviewQueryKey(options)
});

/**
 * Addcomment
 */
export const brandAddCommentMutation = (options?: Partial<Options<BrandAddCommentData>>): UseMutationOptions<BrandAddCommentResponse, BrandAddCommentError, Options<BrandAddCommentData>> => {
    const mutationOptions: UseMutationOptions<BrandAddCommentResponse, BrandAddCommentError, Options<BrandAddCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandAddComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve
 */
export const brandApproveMutation = (options?: Partial<Options<BrandApproveData>>): UseMutationOptions<BrandApproveResponse, BrandApproveError, Options<BrandApproveData>> => {
    const mutationOptions: UseMutationOptions<BrandApproveResponse, BrandApproveError, Options<BrandApproveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandApprove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resolvecomment
 */
export const brandResolveCommentMutation = (options?: Partial<Options<BrandResolveCommentData>>): UseMutationOptions<BrandResolveCommentResponse, BrandResolveCommentError, Options<BrandResolveCommentData>> => {
    const mutationOptions: UseMutationOptions<BrandResolveCommentResponse, BrandResolveCommentError, Options<BrandResolveCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await brandResolveComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const invitationsListQueryKey = (options?: Options<InvitationsListData>) => createQueryKey('invitationsList', options);

/**
 * List
 */
export const invitationsListOptions = (options?: Options<InvitationsListData>) => queryOptions<InvitationsListResponse, InvitationsListError, InvitationsListResponse, ReturnType<typeof invitationsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await invitationsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: invitationsListQueryKey(options)
});

/**
 * Create
 */
export const invitationsCreateMutation = (options?: Partial<Options<InvitationsCreateData>>): UseMutationOptions<InvitationsCreateResponse, InvitationsCreateError, Options<InvitationsCreateData>> => {
    const mutationOptions: UseMutationOptions<InvitationsCreateResponse, InvitationsCreateError, Options<InvitationsCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await invitationsCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke
 */
export const invitationsRevokeMutation = (options?: Partial<Options<InvitationsRevokeData>>): UseMutationOptions<InvitationsRevokeResponse, InvitationsRevokeError, Options<InvitationsRevokeData>> => {
    const mutationOptions: UseMutationOptions<InvitationsRevokeResponse, InvitationsRevokeError, Options<InvitationsRevokeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await invitationsRevoke({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const invitationsPreviewQueryKey = (options: Options<InvitationsPreviewData>) => createQueryKey('invitationsPreview', options);

/**
 * Preview
 */
export const invitationsPreviewOptions = (options: Options<InvitationsPreviewData>) => queryOptions<InvitationsPreviewResponse, InvitationsPreviewError, InvitationsPreviewResponse, ReturnType<typeof invitationsPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await invitationsPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: invitationsPreviewQueryKey(options)
});

/**
 * Accept
 *
 * Set a password and sign in, in one step.
 */
export const invitationsAcceptMutation = (options?: Partial<Options<InvitationsAcceptData>>): UseMutationOptions<InvitationsAcceptResponse, InvitationsAcceptError, Options<InvitationsAcceptData>> => {
    const mutationOptions: UseMutationOptions<InvitationsAcceptResponse, InvitationsAcceptError, Options<InvitationsAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await invitationsAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const frameworksListQueryKey = (options?: Options<FrameworksListData>) => createQueryKey('frameworksList', options);

/**
 * List
 *
 * Everyone who writes a prompt needs the dropdown, so any signed-in user
 * may read this. Only The Motherhood may change it.
 */
export const frameworksListOptions = (options?: Options<FrameworksListData>) => queryOptions<FrameworksListResponse, FrameworksListError, FrameworksListResponse, ReturnType<typeof frameworksListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await frameworksList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: frameworksListQueryKey(options)
});

/**
 * Create
 */
export const frameworksCreateMutation = (options?: Partial<Options<FrameworksCreateData>>): UseMutationOptions<FrameworksCreateResponse, FrameworksCreateError, Options<FrameworksCreateData>> => {
    const mutationOptions: UseMutationOptions<FrameworksCreateResponse, FrameworksCreateError, Options<FrameworksCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await frameworksCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete
 */
export const frameworksDeleteMutation = (options?: Partial<Options<FrameworksDeleteData>>): UseMutationOptions<FrameworksDeleteResponse, FrameworksDeleteError, Options<FrameworksDeleteData>> => {
    const mutationOptions: UseMutationOptions<FrameworksDeleteResponse, FrameworksDeleteError, Options<FrameworksDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await frameworksDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update
 */
export const frameworksUpdateMutation = (options?: Partial<Options<FrameworksUpdateData>>): UseMutationOptions<FrameworksUpdateResponse, FrameworksUpdateError, Options<FrameworksUpdateData>> => {
    const mutationOptions: UseMutationOptions<FrameworksUpdateResponse, FrameworksUpdateError, Options<FrameworksUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await frameworksUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promptsListForConfigQueryKey = (options: Options<PromptsListForConfigData>) => createQueryKey('promptsListForConfig', options);

/**
 * Listforconfig
 */
export const promptsListForConfigOptions = (options: Options<PromptsListForConfigData>) => queryOptions<PromptsListForConfigResponse, PromptsListForConfigError, PromptsListForConfigResponse, ReturnType<typeof promptsListForConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await promptsListForConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: promptsListForConfigQueryKey(options)
});

/**
 * Createforconfig
 */
export const promptsCreateForConfigMutation = (options?: Partial<Options<PromptsCreateForConfigData>>): UseMutationOptions<PromptsCreateForConfigResponse, PromptsCreateForConfigError, Options<PromptsCreateForConfigData>> => {
    const mutationOptions: UseMutationOptions<PromptsCreateForConfigResponse, PromptsCreateForConfigError, Options<PromptsCreateForConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await promptsCreateForConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deleteforconfig
 */
export const promptsDeleteForConfigMutation = (options?: Partial<Options<PromptsDeleteForConfigData>>): UseMutationOptions<PromptsDeleteForConfigResponse, PromptsDeleteForConfigError, Options<PromptsDeleteForConfigData>> => {
    const mutationOptions: UseMutationOptions<PromptsDeleteForConfigResponse, PromptsDeleteForConfigError, Options<PromptsDeleteForConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await promptsDeleteForConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updateforconfig
 */
export const promptsUpdateForConfigMutation = (options?: Partial<Options<PromptsUpdateForConfigData>>): UseMutationOptions<PromptsUpdateForConfigResponse, PromptsUpdateForConfigError, Options<PromptsUpdateForConfigData>> => {
    const mutationOptions: UseMutationOptions<PromptsUpdateForConfigResponse, PromptsUpdateForConfigError, Options<PromptsUpdateForConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await promptsUpdateForConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promptsMineQueryKey = (options?: Options<PromptsMineData>) => createQueryKey('promptsMine', options);

/**
 * Mine
 *
 * The whole library: The Motherhood's prompts and the client's own.
 *
 * An org whose setup is not written yet has an empty library, which is the
 * truth and is what the screen already knows how to show. Reading a list
 * never fails just because the list is empty.
 */
export const promptsMineOptions = (options?: Options<PromptsMineData>) => queryOptions<PromptsMineResponse, PromptsMineError, PromptsMineResponse, ReturnType<typeof promptsMineQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await promptsMine({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: promptsMineQueryKey(options)
});

/**
 * Addmine
 */
export const promptsAddMineMutation = (options?: Partial<Options<PromptsAddMineData>>): UseMutationOptions<PromptsAddMineResponse, PromptsAddMineError, Options<PromptsAddMineData>> => {
    const mutationOptions: UseMutationOptions<PromptsAddMineResponse, PromptsAddMineError, Options<PromptsAddMineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await promptsAddMine({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Duplicatemine
 *
 * Make an editable copy of a prompt, which is how a client reworks one of
 * The Motherhood's without overwriting it.
 */
export const promptsDuplicateMineMutation = (options?: Partial<Options<PromptsDuplicateMineData>>): UseMutationOptions<PromptsDuplicateMineResponse, PromptsDuplicateMineError, Options<PromptsDuplicateMineData>> => {
    const mutationOptions: UseMutationOptions<PromptsDuplicateMineResponse, PromptsDuplicateMineError, Options<PromptsDuplicateMineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await promptsDuplicateMine({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deletemine
 */
export const promptsDeleteMineMutation = (options?: Partial<Options<PromptsDeleteMineData>>): UseMutationOptions<PromptsDeleteMineResponse, PromptsDeleteMineError, Options<PromptsDeleteMineData>> => {
    const mutationOptions: UseMutationOptions<PromptsDeleteMineResponse, PromptsDeleteMineError, Options<PromptsDeleteMineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await promptsDeleteMine({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updatemine
 */
export const promptsUpdateMineMutation = (options?: Partial<Options<PromptsUpdateMineData>>): UseMutationOptions<PromptsUpdateMineResponse, PromptsUpdateMineError, Options<PromptsUpdateMineData>> => {
    const mutationOptions: UseMutationOptions<PromptsUpdateMineResponse, PromptsUpdateMineError, Options<PromptsUpdateMineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await promptsUpdateMine({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const plansListQueryKey = (options?: Options<PlansListData>) => createQueryKey('plansList', options);

/**
 * List
 */
export const plansListOptions = (options?: Options<PlansListData>) => queryOptions<PlansListResponse, PlansListError, PlansListResponse, ReturnType<typeof plansListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await plansList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: plansListQueryKey(options)
});

/**
 * Create
 */
export const plansCreateMutation = (options?: Partial<Options<PlansCreateData>>): UseMutationOptions<PlansCreateResponse, PlansCreateError, Options<PlansCreateData>> => {
    const mutationOptions: UseMutationOptions<PlansCreateResponse, PlansCreateError, Options<PlansCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await plansCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const plansByMonthQueryKey = (options: Options<PlansByMonthData>) => createQueryKey('plansByMonth', options);

/**
 * Bymonth
 *
 * The plan for a given month, or nothing if it has not been started.
 */
export const plansByMonthOptions = (options: Options<PlansByMonthData>) => queryOptions<PlansByMonthResponse, PlansByMonthError, PlansByMonthResponse, ReturnType<typeof plansByMonthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await plansByMonth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: plansByMonthQueryKey(options)
});

/**
 * Delete
 */
export const plansDeleteMutation = (options?: Partial<Options<PlansDeleteData>>): UseMutationOptions<PlansDeleteResponse, PlansDeleteError, Options<PlansDeleteData>> => {
    const mutationOptions: UseMutationOptions<PlansDeleteResponse, PlansDeleteError, Options<PlansDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await plansDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const plansGetQueryKey = (options: Options<PlansGetData>) => createQueryKey('plansGet', options);

/**
 * Get
 */
export const plansGetOptions = (options: Options<PlansGetData>) => queryOptions<PlansGetResponse, PlansGetError, PlansGetResponse, ReturnType<typeof plansGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await plansGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: plansGetQueryKey(options)
});

/**
 * Update
 */
export const plansUpdateMutation = (options?: Partial<Options<PlansUpdateData>>): UseMutationOptions<PlansUpdateResponse, PlansUpdateError, Options<PlansUpdateData>> => {
    const mutationOptions: UseMutationOptions<PlansUpdateResponse, PlansUpdateError, Options<PlansUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await plansUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Addevent
 */
export const plansAddEventMutation = (options?: Partial<Options<PlansAddEventData>>): UseMutationOptions<PlansAddEventResponse, PlansAddEventError, Options<PlansAddEventData>> => {
    const mutationOptions: UseMutationOptions<PlansAddEventResponse, PlansAddEventError, Options<PlansAddEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await plansAddEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deleteevent
 */
export const plansDeleteEventMutation = (options?: Partial<Options<PlansDeleteEventData>>): UseMutationOptions<PlansDeleteEventResponse, PlansDeleteEventError, Options<PlansDeleteEventData>> => {
    const mutationOptions: UseMutationOptions<PlansDeleteEventResponse, PlansDeleteEventError, Options<PlansDeleteEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await plansDeleteEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updateevent
 */
export const plansUpdateEventMutation = (options?: Partial<Options<PlansUpdateEventData>>): UseMutationOptions<PlansUpdateEventResponse, PlansUpdateEventError, Options<PlansUpdateEventData>> => {
    const mutationOptions: UseMutationOptions<PlansUpdateEventResponse, PlansUpdateEventError, Options<PlansUpdateEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await plansUpdateEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Setprompts
 */
export const plansSetPromptsMutation = (options?: Partial<Options<PlansSetPromptsData>>): UseMutationOptions<PlansSetPromptsResponse, PlansSetPromptsError, Options<PlansSetPromptsData>> => {
    const mutationOptions: UseMutationOptions<PlansSetPromptsResponse, PlansSetPromptsError, Options<PlansSetPromptsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await plansSetPrompts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generatemonth
 *
 * Ideas for the page and prompts for every ready teammate, in one press.
 *
 * Afterwards the page's ideas can be regenerated on their own; each
 * teammate rewrites their own prompts from their side, within a monthly cap.
 */
export const plansGenerateMonthMutation = (options?: Partial<Options<PlansGenerateMonthData>>): UseMutationOptions<PlansGenerateMonthResponse, PlansGenerateMonthError, Options<PlansGenerateMonthData>> => {
    const mutationOptions: UseMutationOptions<PlansGenerateMonthResponse, PlansGenerateMonthError, Options<PlansGenerateMonthData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await plansGenerateMonth({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generatepage
 *
 * Ideas for the organisation's own Page, for the SMM to write posts from.
 *
 * Runs inline: this is one model call. The per-employee run below is the one
 * that will move to the worker.
 */
export const plansGeneratePageMutation = (options?: Partial<Options<PlansGeneratePageData>>): UseMutationOptions<PlansGeneratePageResponse, PlansGeneratePageError, Options<PlansGeneratePageData>> => {
    const mutationOptions: UseMutationOptions<PlansGeneratePageResponse, PlansGeneratePageError, Options<PlansGeneratePageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await plansGeneratePage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generateemployees
 *
 * A private set for each employee, from the same month.
 *
 * Their voice profile is not part of this yet; when that feature lands it
 * becomes another block of context and nothing here changes.
 */
export const plansGenerateEmployeesMutation = (options?: Partial<Options<PlansGenerateEmployeesData>>): UseMutationOptions<PlansGenerateEmployeesResponse, PlansGenerateEmployeesError, Options<PlansGenerateEmployeesData>> => {
    const mutationOptions: UseMutationOptions<PlansGenerateEmployeesResponse, PlansGenerateEmployeesError, Options<PlansGenerateEmployeesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await plansGenerateEmployees({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Addpost
 *
 * Schedule a post the SMM has written. The body is always theirs.
 */
export const plansAddPostMutation = (options?: Partial<Options<PlansAddPostData>>): UseMutationOptions<PlansAddPostResponse, PlansAddPostError, Options<PlansAddPostData>> => {
    const mutationOptions: UseMutationOptions<PlansAddPostResponse, PlansAddPostError, Options<PlansAddPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await plansAddPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deletepost
 */
export const plansDeletePostMutation = (options?: Partial<Options<PlansDeletePostData>>): UseMutationOptions<PlansDeletePostResponse, PlansDeletePostError, Options<PlansDeletePostData>> => {
    const mutationOptions: UseMutationOptions<PlansDeletePostResponse, PlansDeletePostError, Options<PlansDeletePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await plansDeletePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updatepost
 */
export const plansUpdatePostMutation = (options?: Partial<Options<PlansUpdatePostData>>): UseMutationOptions<PlansUpdatePostResponse, PlansUpdatePostError, Options<PlansUpdatePostData>> => {
    const mutationOptions: UseMutationOptions<PlansUpdatePostResponse, PlansUpdatePostError, Options<PlansUpdatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await plansUpdatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const voiceOptionsQueryKey = (options?: Options<VoiceOptionsData>) => createQueryKey('voiceOptions', options);

/**
 * Options
 *
 * The words to pick from. Read by anyone signed in, since it is a
 * vocabulary rather than anybody's answers.
 */
export const voiceOptionsOptions = (options?: Options<VoiceOptionsData>) => queryOptions<VoiceOptionsResponse, DefaultError, VoiceOptionsResponse, ReturnType<typeof voiceOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await voiceOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: voiceOptionsQueryKey(options)
});

export const voiceMineQueryKey = (options?: Options<VoiceMineData>) => createQueryKey('voiceMine', options);

/**
 * Mine
 *
 * Null until they start. The row appears on the first save.
 */
export const voiceMineOptions = (options?: Options<VoiceMineData>) => queryOptions<VoiceMineResponse, DefaultError, VoiceMineResponse, ReturnType<typeof voiceMineQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await voiceMine({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: voiceMineQueryKey(options)
});

/**
 * Stageone
 */
export const voiceStageOneMutation = (options?: Partial<Options<VoiceStageOneData>>): UseMutationOptions<VoiceStageOneResponse, VoiceStageOneError, Options<VoiceStageOneData>> => {
    const mutationOptions: UseMutationOptions<VoiceStageOneResponse, VoiceStageOneError, Options<VoiceStageOneData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await voiceStageOne({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stagethree
 */
export const voiceStageThreeMutation = (options?: Partial<Options<VoiceStageThreeData>>): UseMutationOptions<VoiceStageThreeResponse, VoiceStageThreeError, Options<VoiceStageThreeData>> => {
    const mutationOptions: UseMutationOptions<VoiceStageThreeResponse, VoiceStageThreeError, Options<VoiceStageThreeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await voiceStageThree({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Addsample
 */
export const voiceAddSampleMutation = (options?: Partial<Options<VoiceAddSampleData>>): UseMutationOptions<VoiceAddSampleResponse, VoiceAddSampleError, Options<VoiceAddSampleData>> => {
    const mutationOptions: UseMutationOptions<VoiceAddSampleResponse, VoiceAddSampleError, Options<VoiceAddSampleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await voiceAddSample({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deletesample
 */
export const voiceDeleteSampleMutation = (options?: Partial<Options<VoiceDeleteSampleData>>): UseMutationOptions<VoiceDeleteSampleResponse, VoiceDeleteSampleError, Options<VoiceDeleteSampleData>> => {
    const mutationOptions: UseMutationOptions<VoiceDeleteSampleResponse, VoiceDeleteSampleError, Options<VoiceDeleteSampleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await voiceDeleteSample({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updatesample
 */
export const voiceUpdateSampleMutation = (options?: Partial<Options<VoiceUpdateSampleData>>): UseMutationOptions<VoiceUpdateSampleResponse, VoiceUpdateSampleError, Options<VoiceUpdateSampleData>> => {
    const mutationOptions: UseMutationOptions<VoiceUpdateSampleResponse, VoiceUpdateSampleError, Options<VoiceUpdateSampleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await voiceUpdateSample({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const voiceTeamReadinessQueryKey = (options?: Options<VoiceTeamReadinessData>) => createQueryKey('voiceTeamReadiness', options);

/**
 * Teamreadiness
 *
 * How many of the team can be generated for. Two numbers, no names.
 */
export const voiceTeamReadinessOptions = (options?: Options<VoiceTeamReadinessData>) => queryOptions<VoiceTeamReadinessResponse, VoiceTeamReadinessError, VoiceTeamReadinessResponse, ReturnType<typeof voiceTeamReadinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await voiceTeamReadiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: voiceTeamReadinessQueryKey(options)
});

export const generationMyMonthQueryKey = (options?: Options<GenerationMyMonthData>) => createQueryKey('generationMyMonth', options);

/**
 * Mymonth
 *
 * This month's prompts, plus enough context to know why there are none.
 *
 * Always returns a shape. An employee with no prompts needs to know which of
 * three things is true, and a bare empty list tells them none of it.
 */
export const generationMyMonthOptions = (options?: Options<GenerationMyMonthData>) => queryOptions<GenerationMyMonthResponse, DefaultError, GenerationMyMonthResponse, ReturnType<typeof generationMyMonthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generationMyMonth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generationMyMonthQueryKey(options)
});

/**
 * Generatemine
 *
 * Write this month's prompts for the person asking.
 *
 * For whoever joined after the SMM sent the month out, or changed their voice
 * profile since. One model call, for one person; the rest of the team's
 * prompts are untouched. Returns the month as it now reads.
 */
export const generationGenerateMineMutation = (options?: Partial<Options<GenerationGenerateMineData>>): UseMutationOptions<GenerationGenerateMineResponse, DefaultError, Options<GenerationGenerateMineData>> => {
    const mutationOptions: UseMutationOptions<GenerationGenerateMineResponse, DefaultError, Options<GenerationGenerateMineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generationGenerateMine({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dashboardSetupQueryKey = (options?: Options<DashboardSetupData>) => createQueryKey('dashboardSetup', options);

/**
 * Setup
 */
export const dashboardSetupOptions = (options?: Options<DashboardSetupData>) => queryOptions<DashboardSetupResponse, DashboardSetupError, DashboardSetupResponse, ReturnType<typeof dashboardSetupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dashboardSetup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dashboardSetupQueryKey(options)
});

export const dashboardRosterQueryKey = (options?: Options<DashboardRosterData>) => createQueryKey('dashboardRoster', options);

/**
 * Roster
 *
 * Everyone on the team and everyone invited. Counts and states only.
 */
export const dashboardRosterOptions = (options?: Options<DashboardRosterData>) => queryOptions<DashboardRosterResponse, DashboardRosterError, DashboardRosterResponse, ReturnType<typeof dashboardRosterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dashboardRoster({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dashboardRosterQueryKey(options)
});

export const dashboardPillarCoverageQueryKey = (options?: Options<DashboardPillarCoverageData>) => createQueryKey('dashboardPillarCoverage', options);

/**
 * Pillarcoverage
 */
export const dashboardPillarCoverageOptions = (options?: Options<DashboardPillarCoverageData>) => queryOptions<DashboardPillarCoverageResponse, DashboardPillarCoverageError, DashboardPillarCoverageResponse, ReturnType<typeof dashboardPillarCoverageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dashboardPillarCoverage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dashboardPillarCoverageQueryKey(options)
});

export const dashboardPageSnapshotQueryKey = (options?: Options<DashboardPageSnapshotData>) => createQueryKey('dashboardPageSnapshot', options);

/**
 * Pagesnapshot
 */
export const dashboardPageSnapshotOptions = (options?: Options<DashboardPageSnapshotData>) => queryOptions<DashboardPageSnapshotResponse, DashboardPageSnapshotError, DashboardPageSnapshotResponse, ReturnType<typeof dashboardPageSnapshotQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dashboardPageSnapshot({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dashboardPageSnapshotQueryKey(options)
});

export const momentsListQueryKey = (options?: Options<MomentsListData>) => createQueryKey('momentsList', options);

/**
 * List
 *
 * Newest first. `archived` switches to the archived view.
 */
export const momentsListOptions = (options?: Options<MomentsListData>) => queryOptions<MomentsListResponse, MomentsListError, MomentsListResponse, ReturnType<typeof momentsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await momentsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: momentsListQueryKey(options)
});

export const momentsListInfiniteQueryKey = (options?: Options<MomentsListData>): QueryKey<Options<MomentsListData>> => createQueryKey('momentsList', options, true);

/**
 * List
 *
 * Newest first. `archived` switches to the archived view.
 */
export const momentsListInfiniteOptions = (options?: Options<MomentsListData>) => {
    const opts = infiniteQueryOptions<MomentsListResponse, MomentsListError, InfiniteData<MomentsListResponse>, QueryKey<Options<MomentsListData>>, string | null | Pick<QueryKey<Options<MomentsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MomentsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await momentsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: momentsListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Add
 */
export const momentsAddMutation = (options?: Partial<Options<MomentsAddData>>): UseMutationOptions<MomentsAddResponse, MomentsAddError, Options<MomentsAddData>> => {
    const mutationOptions: UseMutationOptions<MomentsAddResponse, MomentsAddError, Options<MomentsAddData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await momentsAdd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const momentsGetQueryKey = (options: Options<MomentsGetData>) => createQueryKey('momentsGet', options);

/**
 * Get
 *
 * One moment, archived or not: an idea's source link always opens it.
 */
export const momentsGetOptions = (options: Options<MomentsGetData>) => queryOptions<MomentsGetResponse, MomentsGetError, MomentsGetResponse, ReturnType<typeof momentsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await momentsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: momentsGetQueryKey(options)
});

/**
 * Update
 */
export const momentsUpdateMutation = (options?: Partial<Options<MomentsUpdateData>>): UseMutationOptions<MomentsUpdateResponse, MomentsUpdateError, Options<MomentsUpdateData>> => {
    const mutationOptions: UseMutationOptions<MomentsUpdateResponse, MomentsUpdateError, Options<MomentsUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await momentsUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive
 *
 * There is no delete. An archived moment keeps its words and its ideas.
 */
export const momentsArchiveMutation = (options?: Partial<Options<MomentsArchiveData>>): UseMutationOptions<MomentsArchiveResponse, MomentsArchiveError, Options<MomentsArchiveData>> => {
    const mutationOptions: UseMutationOptions<MomentsArchiveResponse, MomentsArchiveError, Options<MomentsArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await momentsArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Restore
 */
export const momentsRestoreMutation = (options?: Partial<Options<MomentsRestoreData>>): UseMutationOptions<MomentsRestoreResponse, MomentsRestoreError, Options<MomentsRestoreData>> => {
    const mutationOptions: UseMutationOptions<MomentsRestoreResponse, MomentsRestoreError, Options<MomentsRestoreData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await momentsRestore({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Startmediaupload
 *
 * A signed grant to send one photo or video straight to storage.
 */
export const momentsStartMediaUploadMutation = (options?: Partial<Options<MomentsStartMediaUploadData>>): UseMutationOptions<MomentsStartMediaUploadResponse, MomentsStartMediaUploadError, Options<MomentsStartMediaUploadData>> => {
    const mutationOptions: UseMutationOptions<MomentsStartMediaUploadResponse, MomentsStartMediaUploadError, Options<MomentsStartMediaUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await momentsStartMediaUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirmmedia
 */
export const momentsConfirmMediaMutation = (options?: Partial<Options<MomentsConfirmMediaData>>): UseMutationOptions<MomentsConfirmMediaResponse, MomentsConfirmMediaError, Options<MomentsConfirmMediaData>> => {
    const mutationOptions: UseMutationOptions<MomentsConfirmMediaResponse, MomentsConfirmMediaError, Options<MomentsConfirmMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await momentsConfirmMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Removemedia
 */
export const momentsRemoveMediaMutation = (options?: Partial<Options<MomentsRemoveMediaData>>): UseMutationOptions<MomentsRemoveMediaResponse, MomentsRemoveMediaError, Options<MomentsRemoveMediaData>> => {
    const mutationOptions: UseMutationOptions<MomentsRemoveMediaResponse, MomentsRemoveMediaError, Options<MomentsRemoveMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await momentsRemoveMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Getideas
 *
 * A few suggestions from this moment, added to the Ideas tab. Pressing
 * it again adds more; nothing already made is replaced.
 */
export const momentsGetIdeasMutation = (options?: Partial<Options<MomentsGetIdeasData>>): UseMutationOptions<MomentsGetIdeasResponse, MomentsGetIdeasError, Options<MomentsGetIdeasData>> => {
    const mutationOptions: UseMutationOptions<MomentsGetIdeasResponse, MomentsGetIdeasError, Options<MomentsGetIdeasData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await momentsGetIdeas({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reportsListQueryKey = (options?: Options<ReportsListData>) => createQueryKey('reportsList', options);

/**
 * List
 *
 * Published reports, most recent month first.
 */
export const reportsListOptions = (options?: Options<ReportsListData>) => queryOptions<ReportsListResponse, ReportsListError, ReportsListResponse, ReturnType<typeof reportsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await reportsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: reportsListQueryKey(options)
});

/**
 * Startupload
 */
export const reportsStartUploadMutation = (options?: Partial<Options<ReportsStartUploadData>>): UseMutationOptions<ReportsStartUploadResponse, ReportsStartUploadError, Options<ReportsStartUploadData>> => {
    const mutationOptions: UseMutationOptions<ReportsStartUploadResponse, ReportsStartUploadError, Options<ReportsStartUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reportsStartUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirmupload
 */
export const reportsConfirmUploadMutation = (options?: Partial<Options<ReportsConfirmUploadData>>): UseMutationOptions<ReportsConfirmUploadResponse, ReportsConfirmUploadError, Options<ReportsConfirmUploadData>> => {
    const mutationOptions: UseMutationOptions<ReportsConfirmUploadResponse, ReportsConfirmUploadError, Options<ReportsConfirmUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reportsConfirmUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete
 */
export const reportsDeleteMutation = (options?: Partial<Options<ReportsDeleteData>>): UseMutationOptions<ReportsDeleteResponse, ReportsDeleteError, Options<ReportsDeleteData>> => {
    const mutationOptions: UseMutationOptions<ReportsDeleteResponse, ReportsDeleteError, Options<ReportsDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reportsDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive
 *
 * Nobody in the org can sign in; the data stays; it can be restored.
 */
export const orgsArchiveMutation = (options?: Partial<Options<OrgsArchiveData>>): UseMutationOptions<OrgsArchiveResponse, OrgsArchiveError, Options<OrgsArchiveData>> => {
    const mutationOptions: UseMutationOptions<OrgsArchiveResponse, OrgsArchiveError, Options<OrgsArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgsArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove
 *
 * Start the 90-day clock and send everyone their download.
 */
export const orgsRemoveMutation = (options?: Partial<Options<OrgsRemoveData>>): UseMutationOptions<OrgsRemoveResponse, OrgsRemoveError, Options<OrgsRemoveData>> => {
    const mutationOptions: UseMutationOptions<OrgsRemoveResponse, OrgsRemoveError, Options<OrgsRemoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgsRemove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Restore
 *
 * Back to active, for everyone who had access. Cancels the clock and
 * withdraws the downloads.
 */
export const orgsRestoreMutation = (options?: Partial<Options<OrgsRestoreData>>): UseMutationOptions<OrgsRestoreResponse, OrgsRestoreError, Options<OrgsRestoreData>> => {
    const mutationOptions: UseMutationOptions<OrgsRestoreResponse, OrgsRestoreError, Options<OrgsRestoreData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgsRestore({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const orgsExportsQueryKey = (options: Options<OrgsExportsData>) => createQueryKey('orgsExports', options);

/**
 * Exports
 *
 * Each download a removal made: who it is for and whether it arrived.
 */
export const orgsExportsOptions = (options: Options<OrgsExportsData>) => queryOptions<OrgsExportsResponse, OrgsExportsError, OrgsExportsResponse, ReturnType<typeof orgsExportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orgsExports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orgsExportsQueryKey(options)
});

/**
 * Retry Export
 */
export const orgsRetryExportMutation = (options?: Partial<Options<OrgsRetryExportData>>): UseMutationOptions<OrgsRetryExportResponse, OrgsRetryExportError, Options<OrgsRetryExportData>> => {
    const mutationOptions: UseMutationOptions<OrgsRetryExportResponse, OrgsRetryExportError, Options<OrgsRetryExportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgsRetryExport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Export Link
 *
 * A fresh link to pass along another way, for a download whose email
 * did not arrive. The emailed link stops working.
 */
export const orgsExportLinkMutation = (options?: Partial<Options<OrgsExportLinkData>>): UseMutationOptions<OrgsExportLinkResponse, OrgsExportLinkError, Options<OrgsExportLinkData>> => {
    const mutationOptions: UseMutationOptions<OrgsExportLinkResponse, OrgsExportLinkError, Options<OrgsExportLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await orgsExportLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mentionsSummaryQueryKey = (options?: Options<MentionsSummaryData>) => createQueryKey('mentionsSummary', options);

/**
 * Summary
 *
 * The count for the window and the one before it.
 */
export const mentionsSummaryOptions = (options?: Options<MentionsSummaryData>) => queryOptions<MentionsSummaryResponse, MentionsSummaryError, MentionsSummaryResponse, ReturnType<typeof mentionsSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mentionsSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mentionsSummaryQueryKey(options)
});

export const mentionsListQueryKey = (options?: Options<MentionsListData>) => createQueryKey('mentionsList', options);

/**
 * List
 *
 * Posts that tagged the Page, newest first. A link out, and for the
 * first 48 hours a few words of the post.
 */
export const mentionsListOptions = (options?: Options<MentionsListData>) => queryOptions<MentionsListResponse, MentionsListError, MentionsListResponse, ReturnType<typeof mentionsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mentionsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mentionsListQueryKey(options)
});

export const mentionsListInfiniteQueryKey = (options?: Options<MentionsListData>): QueryKey<Options<MentionsListData>> => createQueryKey('mentionsList', options, true);

/**
 * List
 *
 * Posts that tagged the Page, newest first. A link out, and for the
 * first 48 hours a few words of the post.
 */
export const mentionsListInfiniteOptions = (options?: Options<MentionsListData>) => {
    const opts = infiniteQueryOptions<MentionsListResponse, MentionsListError, InfiniteData<MentionsListResponse>, QueryKey<Options<MentionsListData>>, string | null | Pick<QueryKey<Options<MentionsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MentionsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mentionsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mentionsListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const mentionsMonthQueryKey = (options: Options<MentionsMonthData>) => createQueryKey('mentionsMonth', options);

/**
 * Month
 *
 * The month's count and the change from the month before, for a report.
 */
export const mentionsMonthOptions = (options: Options<MentionsMonthData>) => queryOptions<MentionsMonthResponse, MentionsMonthError, MentionsMonthResponse, ReturnType<typeof mentionsMonthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mentionsMonth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mentionsMonthQueryKey(options)
});

export const monthlyReportsForMonthQueryKey = (options: Options<MonthlyReportsForMonthData>) => createQueryKey('monthlyReportsForMonth', options);

/**
 * For Month
 *
 * Every open client's figures for one month, and who has none yet.
 */
export const monthlyReportsForMonthOptions = (options: Options<MonthlyReportsForMonthData>) => queryOptions<MonthlyReportsForMonthResponse, MonthlyReportsForMonthError, MonthlyReportsForMonthResponse, ReturnType<typeof monthlyReportsForMonthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await monthlyReportsForMonth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: monthlyReportsForMonthQueryKey(options)
});

/**
 * Compute
 *
 * Work a closed month out now for every open client, from what the
 * platform holds today. The nightly job does the same on the 3rd.
 */
export const monthlyReportsComputeMutation = (options?: Partial<Options<MonthlyReportsComputeData>>): UseMutationOptions<MonthlyReportsComputeResponse, MonthlyReportsComputeError, Options<MonthlyReportsComputeData>> => {
    const mutationOptions: UseMutationOptions<MonthlyReportsComputeResponse, MonthlyReportsComputeError, Options<MonthlyReportsComputeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await monthlyReportsCompute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const monthlyReportsMineQueryKey = (options?: Options<MonthlyReportsMineData>) => createQueryKey('monthlyReportsMine', options);

/**
 * Mine
 *
 * The caller's own org, latest month first.
 */
export const monthlyReportsMineOptions = (options?: Options<MonthlyReportsMineData>) => queryOptions<MonthlyReportsMineResponse, MonthlyReportsMineError, MonthlyReportsMineResponse, ReturnType<typeof monthlyReportsMineQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await monthlyReportsMine({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: monthlyReportsMineQueryKey(options)
});

export const auditActionsQueryKey = (options?: Options<AuditActionsData>) => createQueryKey('auditActions', options);

/**
 * Actions
 */
export const auditActionsOptions = (options?: Options<AuditActionsData>) => queryOptions<AuditActionsResponse, DefaultError, AuditActionsResponse, ReturnType<typeof auditActionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auditActions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auditActionsQueryKey(options)
});

export const auditListQueryKey = (options?: Options<AuditListData>) => createQueryKey('auditList', options);

/**
 * List
 */
export const auditListOptions = (options?: Options<AuditListData>) => queryOptions<AuditListResponse, AuditListError, AuditListResponse, ReturnType<typeof auditListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auditList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auditListQueryKey(options)
});

export const auditListInfiniteQueryKey = (options?: Options<AuditListData>): QueryKey<Options<AuditListData>> => createQueryKey('auditList', options, true);

/**
 * List
 */
export const auditListInfiniteOptions = (options?: Options<AuditListData>) => {
    const opts = infiniteQueryOptions<AuditListResponse, AuditListError, InfiniteData<AuditListResponse>, QueryKey<Options<AuditListData>>, string | null | Pick<QueryKey<Options<AuditListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AuditListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await auditList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: auditListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const auditExportQueryKey = (options?: Options<AuditExportData>) => createQueryKey('auditExport', options);

/**
 * Export
 *
 * The matching entries as CSV, newest first, up to ten thousand.
 */
export const auditExportOptions = (options?: Options<AuditExportData>) => queryOptions<unknown, AuditExportError, unknown, ReturnType<typeof auditExportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auditExport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auditExportQueryKey(options)
});

export const auditMineQueryKey = (options?: Options<AuditMineData>) => createQueryKey('auditMine', options);

/**
 * Mine
 *
 * A client's own org: what its manager and The Motherhood did to it.
 */
export const auditMineOptions = (options?: Options<AuditMineData>) => queryOptions<AuditMineResponse, AuditMineError, AuditMineResponse, ReturnType<typeof auditMineQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auditMine({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auditMineQueryKey(options)
});

export const auditMineInfiniteQueryKey = (options?: Options<AuditMineData>): QueryKey<Options<AuditMineData>> => createQueryKey('auditMine', options, true);

/**
 * Mine
 *
 * A client's own org: what its manager and The Motherhood did to it.
 */
export const auditMineInfiniteOptions = (options?: Options<AuditMineData>) => {
    const opts = infiniteQueryOptions<AuditMineResponse, AuditMineError, InfiniteData<AuditMineResponse>, QueryKey<Options<AuditMineData>>, string | null | Pick<QueryKey<Options<AuditMineData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AuditMineData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await auditMine({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: auditMineInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const downloadsGetQueryKey = (options: Options<DownloadsGetData>) => createQueryKey('downloadsGet', options);

/**
 * Get
 *
 * No login: the token is the permission, and it ends with the 90 days.
 */
export const downloadsGetOptions = (options: Options<DownloadsGetData>) => queryOptions<DownloadsGetResponse, DownloadsGetError, DownloadsGetResponse, ReturnType<typeof downloadsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadsGetQueryKey(options)
});

export const downloadsFileQueryKey = (options: Options<DownloadsFileData>) => createQueryKey('downloadsFile', options);

/**
 * File
 */
export const downloadsFileOptions = (options: Options<DownloadsFileData>) => queryOptions<unknown, DownloadsFileError, unknown, ReturnType<typeof downloadsFileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadsFile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadsFileQueryKey(options)
});

/**
 * Email
 *
 * Bounces, so the Super Admin sees a download email that did not arrive.
 * Only removal downloads track delivery today; other events are ignored.
 */
export const webhooksEmailMutation = (options?: Partial<Options<WebhooksEmailData>>): UseMutationOptions<WebhooksEmailResponse, WebhooksEmailError, Options<WebhooksEmailData>> => {
    const mutationOptions: UseMutationOptions<WebhooksEmailResponse, WebhooksEmailError, Options<WebhooksEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await webhooksEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const notebookCountsQueryKey = (options?: Options<NotebookCountsData>) => createQueryKey('notebookCounts', options);

/**
 * Counts
 */
export const notebookCountsOptions = (options?: Options<NotebookCountsData>) => queryOptions<NotebookCountsResponse, DefaultError, NotebookCountsResponse, ReturnType<typeof notebookCountsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await notebookCounts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: notebookCountsQueryKey(options)
});

export const notebookPillarsQueryKey = (options?: Options<NotebookPillarsData>) => createQueryKey('notebookPillars', options);

/**
 * Pillars
 *
 * The org's content pillars, for tagging a post in Compose.
 */
export const notebookPillarsOptions = (options?: Options<NotebookPillarsData>) => queryOptions<NotebookPillarsResponse, DefaultError, NotebookPillarsResponse, ReturnType<typeof notebookPillarsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await notebookPillars({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: notebookPillarsQueryKey(options)
});

export const notebookIdeasQueryKey = (options?: Options<NotebookIdeasData>) => createQueryKey('notebookIdeas', options);

/**
 * Ideas
 *
 * Every suggestion, from moments and from each month's plan, newest first.
 */
export const notebookIdeasOptions = (options?: Options<NotebookIdeasData>) => queryOptions<NotebookIdeasResponse, NotebookIdeasError, NotebookIdeasResponse, ReturnType<typeof notebookIdeasQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await notebookIdeas({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: notebookIdeasQueryKey(options)
});

export const notebookIdeasInfiniteQueryKey = (options?: Options<NotebookIdeasData>): QueryKey<Options<NotebookIdeasData>> => createQueryKey('notebookIdeas', options, true);

/**
 * Ideas
 *
 * Every suggestion, from moments and from each month's plan, newest first.
 */
export const notebookIdeasInfiniteOptions = (options?: Options<NotebookIdeasData>) => {
    const opts = infiniteQueryOptions<NotebookIdeasResponse, NotebookIdeasError, InfiniteData<NotebookIdeasResponse>, QueryKey<Options<NotebookIdeasData>>, string | null | Pick<QueryKey<Options<NotebookIdeasData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<NotebookIdeasData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await notebookIdeas({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: notebookIdeasInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Updateidea
 */
export const notebookUpdateIdeaMutation = (options?: Partial<Options<NotebookUpdateIdeaData>>): UseMutationOptions<NotebookUpdateIdeaResponse, NotebookUpdateIdeaError, Options<NotebookUpdateIdeaData>> => {
    const mutationOptions: UseMutationOptions<NotebookUpdateIdeaResponse, NotebookUpdateIdeaError, Options<NotebookUpdateIdeaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await notebookUpdateIdea({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archiveidea
 */
export const notebookArchiveIdeaMutation = (options?: Partial<Options<NotebookArchiveIdeaData>>): UseMutationOptions<NotebookArchiveIdeaResponse, NotebookArchiveIdeaError, Options<NotebookArchiveIdeaData>> => {
    const mutationOptions: UseMutationOptions<NotebookArchiveIdeaResponse, NotebookArchiveIdeaError, Options<NotebookArchiveIdeaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await notebookArchiveIdea({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Restoreidea
 */
export const notebookRestoreIdeaMutation = (options?: Partial<Options<NotebookRestoreIdeaData>>): UseMutationOptions<NotebookRestoreIdeaResponse, NotebookRestoreIdeaError, Options<NotebookRestoreIdeaData>> => {
    const mutationOptions: UseMutationOptions<NotebookRestoreIdeaResponse, NotebookRestoreIdeaError, Options<NotebookRestoreIdeaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await notebookRestoreIdea({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assetsListQueryKey = (options?: Options<AssetsListData>) => createQueryKey('assetsList', options);

/**
 * List
 *
 * Approved images in the org, newest first, a page at a time. `q`
 * matches the name or the description.
 */
export const assetsListOptions = (options?: Options<AssetsListData>) => queryOptions<AssetsListResponse, AssetsListError, AssetsListResponse, ReturnType<typeof assetsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await assetsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: assetsListQueryKey(options)
});

export const assetsListInfiniteQueryKey = (options?: Options<AssetsListData>): QueryKey<Options<AssetsListData>> => createQueryKey('assetsList', options, true);

/**
 * List
 *
 * Approved images in the org, newest first, a page at a time. `q`
 * matches the name or the description.
 */
export const assetsListInfiniteOptions = (options?: Options<AssetsListData>) => {
    const opts = infiniteQueryOptions<AssetsListResponse, AssetsListError, InfiniteData<AssetsListResponse>, QueryKey<Options<AssetsListData>>, string | null | Pick<QueryKey<Options<AssetsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AssetsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await assetsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: assetsListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Startupload
 *
 * A signed grant to send one image straight to storage. Confirm it after.
 */
export const assetsStartUploadMutation = (options?: Partial<Options<AssetsStartUploadData>>): UseMutationOptions<AssetsStartUploadResponse, AssetsStartUploadError, Options<AssetsStartUploadData>> => {
    const mutationOptions: UseMutationOptions<AssetsStartUploadResponse, AssetsStartUploadError, Options<AssetsStartUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assetsStartUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirmupload
 *
 * The file has landed: check it with the store and show it to the org.
 */
export const assetsConfirmUploadMutation = (options?: Partial<Options<AssetsConfirmUploadData>>): UseMutationOptions<AssetsConfirmUploadResponse, AssetsConfirmUploadError, Options<AssetsConfirmUploadData>> => {
    const mutationOptions: UseMutationOptions<AssetsConfirmUploadResponse, AssetsConfirmUploadError, Options<AssetsConfirmUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assetsConfirmUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete
 *
 * Permanent. The file and the row go together.
 */
export const assetsDeleteMutation = (options?: Partial<Options<AssetsDeleteData>>): UseMutationOptions<AssetsDeleteResponse, AssetsDeleteError, Options<AssetsDeleteData>> => {
    const mutationOptions: UseMutationOptions<AssetsDeleteResponse, AssetsDeleteError, Options<AssetsDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assetsDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update
 */
export const assetsUpdateMutation = (options?: Partial<Options<AssetsUpdateData>>): UseMutationOptions<AssetsUpdateResponse, AssetsUpdateError, Options<AssetsUpdateData>> => {
    const mutationOptions: UseMutationOptions<AssetsUpdateResponse, AssetsUpdateError, Options<AssetsUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assetsUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const activitiesListQueryKey = (options?: Options<ActivitiesListData>) => createQueryKey('activitiesList', options);

/**
 * List
 */
export const activitiesListOptions = (options?: Options<ActivitiesListData>) => queryOptions<ActivitiesListResponse, DefaultError, ActivitiesListResponse, ReturnType<typeof activitiesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await activitiesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: activitiesListQueryKey(options)
});

/**
 * Create
 *
 * Appears in every employee's picker immediately, this week included.
 */
export const activitiesCreateMutation = (options?: Partial<Options<ActivitiesCreateData>>): UseMutationOptions<ActivitiesCreateResponse, ActivitiesCreateError, Options<ActivitiesCreateData>> => {
    const mutationOptions: UseMutationOptions<ActivitiesCreateResponse, ActivitiesCreateError, Options<ActivitiesCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await activitiesCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reorder
 */
export const activitiesReorderMutation = (options?: Partial<Options<ActivitiesReorderData>>): UseMutationOptions<ActivitiesReorderResponse, ActivitiesReorderError, Options<ActivitiesReorderData>> => {
    const mutationOptions: UseMutationOptions<ActivitiesReorderResponse, ActivitiesReorderError, Options<ActivitiesReorderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await activitiesReorder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete
 *
 * Out of the picker for future weeks. Weeks already using it keep it.
 */
export const activitiesDeleteMutation = (options?: Partial<Options<ActivitiesDeleteData>>): UseMutationOptions<ActivitiesDeleteResponse, ActivitiesDeleteError, Options<ActivitiesDeleteData>> => {
    const mutationOptions: UseMutationOptions<ActivitiesDeleteResponse, ActivitiesDeleteError, Options<ActivitiesDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await activitiesDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update
 *
 * The new words apply everywhere the activity already appears.
 */
export const activitiesUpdateMutation = (options?: Partial<Options<ActivitiesUpdateData>>): UseMutationOptions<ActivitiesUpdateResponse, ActivitiesUpdateError, Options<ActivitiesUpdateData>> => {
    const mutationOptions: UseMutationOptions<ActivitiesUpdateResponse, ActivitiesUpdateError, Options<ActivitiesUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await activitiesUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trackerGetQueryKey = (options?: Options<TrackerGetData>) => createQueryKey('trackerGet', options);

/**
 * Get
 */
export const trackerGetOptions = (options?: Options<TrackerGetData>) => queryOptions<TrackerGetResponse, DefaultError, TrackerGetResponse, ReturnType<typeof trackerGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await trackerGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: trackerGetQueryKey(options)
});

/**
 * Updatesettings
 */
export const trackerUpdateSettingsMutation = (options?: Partial<Options<TrackerUpdateSettingsData>>): UseMutationOptions<TrackerUpdateSettingsResponse, TrackerUpdateSettingsError, Options<TrackerUpdateSettingsData>> => {
    const mutationOptions: UseMutationOptions<TrackerUpdateSettingsResponse, TrackerUpdateSettingsError, Options<TrackerUpdateSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await trackerUpdateSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Pick
 *
 * Pick an activity for this week, or one more of one already picked.
 */
export const trackerPickMutation = (options?: Partial<Options<TrackerPickData>>): UseMutationOptions<TrackerPickResponse, TrackerPickError, Options<TrackerPickData>> => {
    const mutationOptions: UseMutationOptions<TrackerPickResponse, TrackerPickError, Options<TrackerPickData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await trackerPick({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Less
 */
export const trackerLessMutation = (options?: Partial<Options<TrackerLessData>>): UseMutationOptions<TrackerLessResponse, TrackerLessError, Options<TrackerLessData>> => {
    const mutationOptions: UseMutationOptions<TrackerLessResponse, TrackerLessError, Options<TrackerLessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await trackerLess({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Tap
 */
export const trackerTapMutation = (options?: Partial<Options<TrackerTapData>>): UseMutationOptions<TrackerTapResponse, TrackerTapError, Options<TrackerTapData>> => {
    const mutationOptions: UseMutationOptions<TrackerTapResponse, TrackerTapError, Options<TrackerTapData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await trackerTap({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Undo
 */
export const trackerUndoMutation = (options?: Partial<Options<TrackerUndoData>>): UseMutationOptions<TrackerUndoResponse, TrackerUndoError, Options<TrackerUndoData>> => {
    const mutationOptions: UseMutationOptions<TrackerUndoResponse, TrackerUndoError, Options<TrackerUndoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await trackerUndo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trackerHistoryQueryKey = (options?: Options<TrackerHistoryData>) => createQueryKey('trackerHistory', options);

/**
 * History
 *
 * Past weeks, newest first, read-only.
 */
export const trackerHistoryOptions = (options?: Options<TrackerHistoryData>) => queryOptions<TrackerHistoryResponse, DefaultError, TrackerHistoryResponse, ReturnType<typeof trackerHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await trackerHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: trackerHistoryQueryKey(options)
});

export const draftsPostingSummaryQueryKey = (options?: Options<DraftsPostingSummaryData>) => createQueryKey('draftsPostingSummary', options);

/**
 * Postingsummary
 *
 * How the team is posting. Counts and public reactions, no names, no text.
 */
export const draftsPostingSummaryOptions = (options?: Options<DraftsPostingSummaryData>) => queryOptions<DraftsPostingSummaryResponse, DraftsPostingSummaryError, DraftsPostingSummaryResponse, ReturnType<typeof draftsPostingSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await draftsPostingSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: draftsPostingSummaryQueryKey(options)
});

export const draftsListQueryKey = (options?: Options<DraftsListData>) => createQueryKey('draftsList', options);

/**
 * List
 */
export const draftsListOptions = (options?: Options<DraftsListData>) => queryOptions<DraftsListResponse, DefaultError, DraftsListResponse, ReturnType<typeof draftsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await draftsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: draftsListQueryKey(options)
});

/**
 * Create
 */
export const draftsCreateMutation = (options?: Partial<Options<DraftsCreateData>>): UseMutationOptions<DraftsCreateResponse, DraftsCreateError, Options<DraftsCreateData>> => {
    const mutationOptions: UseMutationOptions<DraftsCreateResponse, DraftsCreateError, Options<DraftsCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await draftsCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete
 */
export const draftsDeleteMutation = (options?: Partial<Options<DraftsDeleteData>>): UseMutationOptions<DraftsDeleteResponse, DraftsDeleteError, Options<DraftsDeleteData>> => {
    const mutationOptions: UseMutationOptions<DraftsDeleteResponse, DraftsDeleteError, Options<DraftsDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await draftsDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const draftsGetQueryKey = (options: Options<DraftsGetData>) => createQueryKey('draftsGet', options);

/**
 * Get
 */
export const draftsGetOptions = (options: Options<DraftsGetData>) => queryOptions<DraftsGetResponse, DraftsGetError, DraftsGetResponse, ReturnType<typeof draftsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await draftsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: draftsGetQueryKey(options)
});

/**
 * Update
 */
export const draftsUpdateMutation = (options?: Partial<Options<DraftsUpdateData>>): UseMutationOptions<DraftsUpdateResponse, DraftsUpdateError, Options<DraftsUpdateData>> => {
    const mutationOptions: UseMutationOptions<DraftsUpdateResponse, DraftsUpdateError, Options<DraftsUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await draftsUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const draftsHistoryQueryKey = (options: Options<DraftsHistoryData>) => createQueryKey('draftsHistory', options);

/**
 * History
 *
 * One post's full reading history, for its own chart. Bounded to this post,
 * so it never grows with the org's or the platform's total history.
 */
export const draftsHistoryOptions = (options: Options<DraftsHistoryData>) => queryOptions<DraftsHistoryResponse, DraftsHistoryError, DraftsHistoryResponse, ReturnType<typeof draftsHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await draftsHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: draftsHistoryQueryKey(options)
});

/**
 * Previewpost
 *
 * Read the pasted link and show what we found, without recording it yet.
 *
 * This is the confirm step: the person sees the real author and text and can
 * tell at a glance whether the link is right. Nothing is marked posted here.
 */
export const draftsPreviewPostMutation = (options?: Partial<Options<DraftsPreviewPostData>>): UseMutationOptions<DraftsPreviewPostResponse, DraftsPreviewPostError, Options<DraftsPreviewPostData>> => {
    const mutationOptions: UseMutationOptions<DraftsPreviewPostResponse, DraftsPreviewPostError, Options<DraftsPreviewPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await draftsPreviewPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirmposted
 *
 * Yes, that is the post. Commit it; the previewed reading becomes the first
 * snapshot and the daily-then-weekly schedule starts. No second fetch.
 */
export const draftsConfirmPostedMutation = (options?: Partial<Options<DraftsConfirmPostedData>>): UseMutationOptions<DraftsConfirmPostedResponse, DraftsConfirmPostedError, Options<DraftsConfirmPostedData>> => {
    const mutationOptions: UseMutationOptions<DraftsConfirmPostedResponse, DraftsConfirmPostedError, Options<DraftsConfirmPostedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await draftsConfirmPosted({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Discardpreview
 *
 * Not the right post. Throw the look away and go back to editing.
 */
export const draftsDiscardPreviewMutation = (options?: Partial<Options<DraftsDiscardPreviewData>>): UseMutationOptions<DraftsDiscardPreviewResponse, DraftsDiscardPreviewError, Options<DraftsDiscardPreviewData>> => {
    const mutationOptions: UseMutationOptions<DraftsDiscardPreviewResponse, DraftsDiscardPreviewError, Options<DraftsDiscardPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await draftsDiscardPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const draftsGrowthQueryKey = (options?: Options<DraftsGrowthData>) => createQueryKey('draftsGrowth', options);

/**
 * Growth
 */
export const draftsGrowthOptions = (options?: Options<DraftsGrowthData>) => queryOptions<DraftsGrowthResponse, DefaultError, DraftsGrowthResponse, ReturnType<typeof draftsGrowthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await draftsGrowth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: draftsGrowthQueryKey(options)
});

export const analyticsOrgReportQueryKey = (options?: Options<AnalyticsOrgReportData>) => createQueryKey('analyticsOrgReport', options);

/**
 * Orgreport
 *
 * One org's posting: KPIs, a line per teammate, and a six-month trend.
 */
export const analyticsOrgReportOptions = (options?: Options<AnalyticsOrgReportData>) => queryOptions<AnalyticsOrgReportResponse, AnalyticsOrgReportError, AnalyticsOrgReportResponse, ReturnType<typeof analyticsOrgReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await analyticsOrgReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: analyticsOrgReportQueryKey(options)
});

export const analyticsCrossOrgReportQueryKey = (options?: Options<AnalyticsCrossOrgReportData>) => createQueryKey('analyticsCrossOrgReport', options);

/**
 * Crossorgreport
 *
 * Every client org rolled up: totals, a line per org, and a six-month trend.
 */
export const analyticsCrossOrgReportOptions = (options?: Options<AnalyticsCrossOrgReportData>) => queryOptions<AnalyticsCrossOrgReportResponse, AnalyticsCrossOrgReportError, AnalyticsCrossOrgReportResponse, ReturnType<typeof analyticsCrossOrgReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await analyticsCrossOrgReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: analyticsCrossOrgReportQueryKey(options)
});

/**
 * Disconnect
 *
 * Stop acting for the pages and forget the keys. Every page's stats stay.
 */
export const socialPageDisconnectMutation = (options?: Partial<Options<SocialPageDisconnectData>>): UseMutationOptions<SocialPageDisconnectResponse, SocialPageDisconnectError, Options<SocialPageDisconnectData>> => {
    const mutationOptions: UseMutationOptions<SocialPageDisconnectResponse, SocialPageDisconnectError, Options<SocialPageDisconnectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialPageDisconnect({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const socialPageStatusQueryKey = (options?: Options<SocialPageStatusData>) => createQueryKey('socialPageStatus', options);

/**
 * Status
 *
 * Whether the pages are connected, as whom, and anything that went wrong.
 */
export const socialPageStatusOptions = (options?: Options<SocialPageStatusData>) => queryOptions<SocialPageStatusResponse, SocialPageStatusError, SocialPageStatusResponse, ReturnType<typeof socialPageStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await socialPageStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: socialPageStatusQueryKey(options)
});

/**
 * Connect
 *
 * Where to send the SMM to approve access to their pages.
 */
export const socialPageConnectMutation = (options?: Partial<Options<SocialPageConnectData>>): UseMutationOptions<SocialPageConnectResponse, SocialPageConnectError, Options<SocialPageConnectData>> => {
    const mutationOptions: UseMutationOptions<SocialPageConnectResponse, SocialPageConnectError, Options<SocialPageConnectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialPageConnect({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refreshpages
 *
 * Ask the vendor again which pages the account runs.
 */
export const socialPageRefreshPagesMutation = (options?: Partial<Options<SocialPageRefreshPagesData>>): UseMutationOptions<SocialPageRefreshPagesResponse, SocialPageRefreshPagesError, Options<SocialPageRefreshPagesData>> => {
    const mutationOptions: UseMutationOptions<SocialPageRefreshPagesResponse, SocialPageRefreshPagesError, Options<SocialPageRefreshPagesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialPageRefreshPages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Selectpages
 *
 * Which of the listed pages to track. Nothing is deleted either way.
 */
export const socialPageSelectPagesMutation = (options?: Partial<Options<SocialPageSelectPagesData>>): UseMutationOptions<SocialPageSelectPagesResponse, SocialPageSelectPagesError, Options<SocialPageSelectPagesData>> => {
    const mutationOptions: UseMutationOptions<SocialPageSelectPagesResponse, SocialPageSelectPagesError, Options<SocialPageSelectPagesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialPageSelectPages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Setprimary
 *
 * Make this the page the org means by default. Nothing is deleted.
 */
export const socialPageSetPrimaryMutation = (options?: Partial<Options<SocialPageSetPrimaryData>>): UseMutationOptions<SocialPageSetPrimaryResponse, SocialPageSetPrimaryError, Options<SocialPageSetPrimaryData>> => {
    const mutationOptions: UseMutationOptions<SocialPageSetPrimaryResponse, SocialPageSetPrimaryError, Options<SocialPageSetPrimaryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialPageSetPrimary({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sync
 *
 * Fetch now rather than waiting for tonight. The same work the job does,
 * rate limited because the vendor meters the admin's token by the day.
 */
export const socialPageSyncMutation = (options?: Partial<Options<SocialPageSyncData>>): UseMutationOptions<SocialPageSyncResponse, SocialPageSyncError, Options<SocialPageSyncData>> => {
    const mutationOptions: UseMutationOptions<SocialPageSyncResponse, SocialPageSyncError, Options<SocialPageSyncData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialPageSync({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const socialPagePostHistoryQueryKey = (options: Options<SocialPagePostHistoryData>) => createQueryKey('socialPagePostHistory', options);

/**
 * Posthistory
 *
 * One page post's readings over time, for its own chart.
 */
export const socialPagePostHistoryOptions = (options: Options<SocialPagePostHistoryData>) => queryOptions<SocialPagePostHistoryResponse, SocialPagePostHistoryError, SocialPagePostHistoryResponse, ReturnType<typeof socialPagePostHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await socialPagePostHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: socialPagePostHistoryQueryKey(options)
});

export const socialPageAnalyticsQueryKey = (options?: Options<SocialPageAnalyticsData>) => createQueryKey('socialPageAnalytics', options);

/**
 * Analytics
 *
 * How a page did: totals, a trend, and the posts that carried it. The
 * primary page unless one is named.
 */
export const socialPageAnalyticsOptions = (options?: Options<SocialPageAnalyticsData>) => queryOptions<SocialPageAnalyticsResponse, SocialPageAnalyticsError, SocialPageAnalyticsResponse, ReturnType<typeof socialPageAnalyticsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await socialPageAnalytics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: socialPageAnalyticsQueryKey(options)
});

export const socialPageAnalyticsInfiniteQueryKey = (options?: Options<SocialPageAnalyticsData>): QueryKey<Options<SocialPageAnalyticsData>> => createQueryKey('socialPageAnalytics', options, true);

/**
 * Analytics
 *
 * How a page did: totals, a trend, and the posts that carried it. The
 * primary page unless one is named.
 */
export const socialPageAnalyticsInfiniteOptions = (options?: Options<SocialPageAnalyticsData>) => {
    const opts = infiniteQueryOptions<SocialPageAnalyticsResponse, SocialPageAnalyticsError, InfiniteData<SocialPageAnalyticsResponse>, QueryKey<Options<SocialPageAnalyticsData>>, string | null | Pick<QueryKey<Options<SocialPageAnalyticsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<SocialPageAnalyticsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await socialPageAnalytics({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: socialPageAnalyticsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Publishpost
 *
 * Put a planned post on a page, now: the named one, or the primary.
 */
export const socialPagePublishPostMutation = (options?: Partial<Options<SocialPagePublishPostData>>): UseMutationOptions<SocialPagePublishPostResponse, SocialPagePublishPostError, Options<SocialPagePublishPostData>> => {
    const mutationOptions: UseMutationOptions<SocialPagePublishPostResponse, SocialPagePublishPostError, Options<SocialPagePublishPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await socialPagePublishPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const systemHealthQueryKey = (options?: Options<SystemHealthData>) => createQueryKey('systemHealth', options);

/**
 * Health
 *
 * Worker, scheduled jobs, work that has fallen behind, and recent failures.
 */
export const systemHealthOptions = (options?: Options<SystemHealthData>) => queryOptions<SystemHealthResponse, DefaultError, SystemHealthResponse, ReturnType<typeof systemHealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemHealthQueryKey(options)
});

export const systemErrorsQueryKey = (options?: Options<SystemErrorsData>) => createQueryKey('systemErrors', options);

/**
 * Errors
 *
 * Every recorded error, newest first, with its traceback and context.
 */
export const systemErrorsOptions = (options?: Options<SystemErrorsData>) => queryOptions<SystemErrorsResponse, SystemErrorsError, SystemErrorsResponse, ReturnType<typeof systemErrorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await systemErrors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: systemErrorsQueryKey(options)
});

/**
 * Report
 *
 * The browser met an error. Kept like any other, marked as from the web,
 * with who was signed in and where they were. Limited per person, because
 * a page stuck in a loop must not fill the table.
 */
export const systemReportMutation = (options?: Partial<Options<SystemReportData>>): UseMutationOptions<SystemReportResponse, SystemReportError, Options<SystemReportData>> => {
    const mutationOptions: UseMutationOptions<SystemReportResponse, SystemReportError, Options<SystemReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await systemReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
